<template>
  <div>
    <v-card-text>
        <v-alert
            type="warning"
            :value="true"
        >
            <b>Form Number and Party Name are deprecated</b><br />
            We strongly recommend using Case objects to organize your forms.
        </v-alert>
        <br />
        <v-expand-transition>
            <div
                v-if="local_userform"
            >
                    <v-text-field
                        v-model="local_userform.party_name"
                        persistent-hint
                        solo
                        hint="Party Name - Identify the claimant or injured Party"
                    />
                    <v-text-field
                        v-model="local_userform.form_number"
                        persistent-hint
                        solo
                        hint="Form Number - An identifier for this Form related to the Party"
                    />
            </div>
        </v-expand-transition>
    </v-card-text>
    <v-card-actions>
        <v-spacer />
        <v-btn
            flat
            @click="$emit('cancel')"
        >
            Cancel
        </v-btn>
        <v-btn
            color="primary"
            @click="save"
        >
            Save
        </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import api from '@/api'

export default {
    name: 'UserFormSettings',
    props: ['userform', 'id'],
    data () {
        return {
            loading: false,
            local_userform: null
        }
    },
    created () {
        if (this.userform) {
            this.local_userform = JSON.parse(JSON.stringify(this.userform))
        } else {
            if (this.id)
                this.fetch()
        }
    },
    methods: {
        fetch () {
            this.loading = true
            api.userform.userForm.get(this.id)
                .then((data) => {
                    this.local_userform = data
                })
                .finally(() => {
                    this.loading = false
                })

        },
        save () {
            var tmpObj = {
                id: this.local_userform.id,
                party_name: this.local_userform.party_name,
                form_number: this.local_userform.form_number,
                tags: this.local_userform.tags
            }
            api.userform.userForm.save(tmpObj)
                .finally(() => {
                    this.$emit('save')
                })
        }
    }
}
</script>

<style>

</style>